import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Ad Aggregations List
 */
export class AdAggregationsListValueObject extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Array<AdAggregationsValueObject>} deps.items
   */

  getItems = () => this._items
}
